export default __webpack_public_path__ + "static/media/John.4258c3dd.png";